// removed by extract-text-webpack-plugin
module.exports = {"baseUnitValue":"8px","container":"_2Hn-m6OTHlf-t4dsVkMD9V","title":"_2A6LySjd4m54L23hjP4ro"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/loginPage/loginPage.css
// module id = 1068
// module chunks = 0